import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { ScorecardLink } from "../../../Component/Model/Dto/PeopleScorecardLink";
import { DateFormatter } from "../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";

interface ScorecardLinkRows {
    ScorecardId : string;
    ScorecardName : string;
    ScorecardType : string;
    LinkedDate : string;
    // Actions: ActionType[];
}


export interface ScorecardLinkTable {
    columns: Array<TableColumn>;
    rows: Array<ScorecardLinkRows>;
}

export function ScorecardLinksTableMapper(dataObject: ScorecardLink.DtoOut[], unlinkScorecard: (id: string) => void): ScorecardLinkTable {
    const columns = [
        { Header: 'Name', accessor: 'ScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Scorecard Type', accessor: 'ScorecardType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Linked Date', accessor: 'LinkedDate', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        // { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject.length > 0) {
        const rows = dataObject.map((item: ScorecardLink.DtoOut, index: number) => {
            return {
                ScorecardId: item.scorecardId,
                ScorecardName: item.scorecardName,
                ScorecardType: item.scorecardType,
                LinkedDate: item.linkedDate ? DateFormatter(item.linkedDate.toString()) : '',
                // Actions: [
                //     {
                //         key: index.toString(),
                //         label: 'Unlink',
                //         action: () => {
                //             unlinkScorecard(item.scorecardId);
                //         },
                //         icon: {
                //             name: 'remove_circle_icon ',
                //             color: 'error',
                //         }
                //     },
                // ]

            }
        });
        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}
